var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"10%"}},[_c('el-skeleton',{attrs:{"rows":6,"animated":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }